<!-- 企业入驻信息 -->
<style lang="scss" scoped>
.company-item-wrapper {
  background: #ffffff;

  .company-item-upload-box {
    display: flex;
    justify-content: space-between;

    .label {
      display: flex;
      justify-content: space-between;
    }
  }

  .required {
    &::before {
      content: '*';
      color: #ff0000;
      margin-right: 4px;
    }
  }

  .example {
    height: 28px;
    color: $color-primary;
    cursor: pointer;
    border-bottom: 1px solid $color-primary;
  }
}

.no-show-star {
  :deep() {
    .el-form-item__label {
      width: 100% !important;
      text-align: end;
      height: 22px;
      &::before {
        content: '' !important;
      }
    }
  }
}
</style>

<template>
  <div class="company-item-wrapper">
    <el-form ref="formRef" :model="form" :rules="rules" size="large" label-position="top" label-width="90px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="证件类型" prop="legalIdentityCardType">
            <el-select v-model="form.legalIdentityCardType" placeholder="请选择证件类型" @change="$emit('blur-event', 'legalIdentityCardType')">
              <el-option v-for="item in ID_TYPE_LIST" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="法人姓名" prop="legalName">
            <el-input v-model="form.legalName" placeholder="请输入法人姓名" @blur="$emit('blur-event', 'legalName')" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="证件号码" prop="legalIdentityCard">
            <el-input v-model="form.legalIdentityCard" placeholder="请输入证件号码" @blur="$emit('blur-event', 'legalIdentityCard')" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="签发机关" prop="legalIdentityCardIssuingAuthority">
            <el-input v-model="form.legalIdentityCardIssuingAuthority" placeholder="请输入签发机关" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="法人证件有效期" prop="legalIdentityCardFromDate">
            <el-date-picker
              v-model="form.legalIdentityCardFromDate"
              style="width: 100%"
              type="date"
              value-format="YYYY-MM-DD"
              placeholder="开始日期"
              @change="$emit('blur-event', 'legalIdentityCardFromDate')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <div class="no-show-star">
            <el-form-item prop="legalIdentityCardEndDate">
              <template #label>
                <el-checkbox
                  v-model="form.legalIdentityCardLongTerm"
                  class="long-term-checkbox"
                  label="结束日期：长期"
                  :true-label="1"
                  :false-label="0"
                  name="type"
                  @change="
                    (e) => {
                      longChange(e, 'legalIdentityCardEndDate')
                      $emit('blur-event', 'legalIdentityCardLongTerm')
                    }
                  "
                />
              </template>
              <el-date-picker
                v-model="form.legalIdentityCardEndDate"
                style="width: 100%"
                :disabled="!!form.legalIdentityCardLongTerm"
                type="date"
                value-format="YYYY-MM-DD"
                placeholder="结束日期"
                @change="$emit('blur-event', 'legalIdentityCardEndDate')"
              />
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="8">
          <el-form-item label="法人手机号" prop="legalPhone">
            <el-input v-model="form.legalPhone" :is-number="true" maxlength="11" placeholder="请输入法人手机号" @blur="$emit('blur-event', 'legalPhone')" />
          </el-form-item>
        </el-col>

        <el-col :span="16">
          <el-form-item label="证件住址" prop="legalHouseholdAddress">
            <el-input v-model="form.legalHouseholdAddress" placeholder="请输入证件住址" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { ID_TYPE_LIST } from '@/constants/common'
import { isPhone, validateIDNumber } from '@/common/js/validator'
import { dealTime } from '@/utils/utils'

const form = ref({
  legalIdentityCardType: 101, // 证件类型
  legalName: '', // 法人姓名
  legalIdentityCard: '', // 证件号码
  legalIdentityCardIssuingAuthority: '', // 签发机关
  legalIdentityCardFromDate: '', // 开始日期
  legalIdentityCardEndDate: '', // 结束日期
  legalIdentityCardLongTerm: 0, // 是否长期
  legalPhone: '', // 法人手机号
  legalHouseholdAddress: '', // 证件住址
  legalIdentityCardFrontUrl: null, // 法定代表人身份证人像面
  legalIdentityCardBackUrl: null, // 法定代表人身份证国徽面
})

const emit = defineEmits(['setFormData', 'blur-event'])

const props = defineProps({
  joinForm: {
    type: Object,
    default: () => {},
  },
})

watch(
  () => form.value,
  (newVal) => {
    //更新joinForm
    emit('setFormData', newVal)
  },
  { deep: true },
)

watch(
  () => props.joinForm,
  (newVal) => {
    if (newVal) {
      //只设置form中存在的字段
      for (const key in newVal) {
        if (newVal[key] !== undefined && newVal[key] !== null && key in form.value) {
          form.value[key] = newVal[key]
        }
      }
    }
  },
  { deep: true, immediate: true },
)
// 自定义手机号码验证规则
const checkPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入手机号码'))
  }
  if (!isPhone(value)) {
    return callback(new Error('输入手机号码格式不对'))
  }
  callback()
}

// 自定义法人证件号验证规则
const checkLegalIdentityCard = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入法人证件号'))
  }
  if (!validateIDNumber(value)) {
    return callback(new Error('输入法人证件号格式不对'))
  }
  callback()
}

// 自定义法人身份证结束日期检验规则
const checkLegalIdentityCardEndDate = (rule, value, callback) => {
  if (form.value.legalIdentityCardFromDate && value && dealTime(form.value.legalIdentityCardFromDate) > dealTime(value)) {
    callback(new Error('结束日期不能小于开始日期'))
  } else if (value || form.value.legalIdentityCardLongTerm) {
    callback()
  } else {
    callback(new Error('请选择结束日期'))
  }
}

//长期赋值
const longChange = (e, key) => {
  e ? (form.value[key] = '2099-12-31') : (form.value[key] = '')
}

const rules = ref({
  legalName: [{ required: true, message: '请输入法人姓名', trigger: ['blur', 'change'] }],
  legalPhone: [{ required: true, validator: checkPhone, trigger: ['blur', 'change'] }],
  legalIdentityCard: [
    {
      required: true,
      validator: checkLegalIdentityCard,
      trigger: ['blur', 'change'],
    },
  ],
  legalIdentityCardFromDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
  legalIdentityCardEndDate: [
    {
      required: true,
      validator: checkLegalIdentityCardEndDate,
      trigger: 'change',
    },
  ],
  legalHouseholdAddress: [
    {
      required: true,
      message: '请输入法人证件地址',
      trigger: ['blur', 'change'],
    },
  ],
  legalIdentityCardType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
  legalIdentityCardIssuingAuthority: [{ required: true, message: '请输入签发机关', trigger: ['blur', 'change'] }],
})

//更新法人信息form数据
const updateForm = (data) => {
  Object.assign(form.value, data)
}

const formRef = ref(null) // 表单ref
defineExpose({
  form: computed(() => form.value),
  validate: () => {
    return formRef.value?.validate()
  },
  updateForm,
})
</script>
